import localFont from 'next/font/local'

export const gibsonFont = localFont({
  src: [
    {
      path: './gibson/light/gibson-light-webfont.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './gibson/regular/gibson-regular-webfont.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './gibson/medium/gibson-medium-webfont.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './gibson/semibold/gibson-semibold-webfont.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: './gibson/bold/gibson-bold-webfont.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './gibson/heavy/gibson-heavy-webfont.woff2',
      weight: '900',
      style: 'normal',
    },
  ],
  variable: '--font-gibson',
})

export const mrsEavesXlFont = localFont({
  src: [
    {
      path: './mrseavesxl/regular/mrseavesxlserot-reg-webfont.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path:
        './mrseavesxl/regularitalic/mrseavesxlserot-regitalic-webfont.woff2',
      weight: '400',
      style: 'italic',
    },
    {
      path: './mrseavesxl/bold/mrseavesxlserot-bold-webfont.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './mrseavesxl/bolditalic/mrseavesxlserot-bolditalic-webfont.woff2',
      weight: '700',
      style: 'italic',
    },
    {
      path: './mrseavesxl/heavy/mrseavesxlserot-heavy-webfont.woff2',
      weight: '900',
      style: 'normal',
    },
    {
      path:
        './mrseavesxl/heavyitalic/mrseavesxlserot-heavyitalic-webfont.woff2',
      weight: '900',
      style: 'italic',
    },
  ],
  variable: '--font-mrseavesxl',
})

export const roboto = localFont({
  src: [
    {
      path: './roboto/light/Roboto-Light-webfont.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './roboto/regular/Roboto-Regular-webfont.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './roboto/medium/Roboto-Medium-webfont.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './roboto/semibold/Roboto-SemiBold-webfont.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: './roboto/bold/Roboto-Bold-webfont.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  variable: '--font-roboto',
})

export const cedarvilleCursive = localFont({
  src: [
    {
      path: './ceaderville_cursive/regular/CedarvilleCursive-Regular.ttf',
      weight: '600',
      style: 'normal',
    },
  ],
  variable: '--font-ceaderville_cursive',
})

export const nextFontVariables = `${roboto.variable} ${gibsonFont.variable} ${mrsEavesXlFont.variable} ${cedarvilleCursive.variable}`
